import { Navigate } from "react-router-dom";
import { useAuthContext } from "./AuthProvider";

const ChatOnlyRoute = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { hasFullControl } = useAuthContext();

  // If user doesn't have FULL_CONTROL permission, redirect them to chat page
  if (!hasFullControl()) {
    return <Navigate to="/chat" replace />;
  }

  return children;
};

export default ChatOnlyRoute;